import React from 'react';
import { LEGAL_PAGES, SEO_META } from '../mock';
import Reveal from '../components/Reveal';
import Seo from '../components/Seo';

const LegalPage = ({ which }) => {
  const page = LEGAL_PAGES[which];

  return (
    <main className="bg-ink">
      <Seo {...(SEO_META[which] || {})} />
      <section className="mx-auto max-w-3xl px-6 pb-20 pt-32 md:pt-36">
        <Reveal>
          <p className="mb-5 flex items-center gap-4 text-[10px] uppercase tracking-[0.5em] text-gold">
            {page.label}
            <span className="h-px w-14 bg-gold/50" />
          </p>
        </Reveal>
        <Reveal delay={120}>
          <h1 className="font-serif text-4xl font-light leading-tight tracking-[0.02em] text-white md:text-6xl">
            {page.title}
          </h1>
        </Reveal>
        <Reveal delay={220}>
          <p className="mt-4 text-[11px] tracking-[0.2em] text-neutral-500">{page.updated}</p>
        </Reveal>
        <Reveal delay={300}>
          <p className="mt-8 border-l-2 border-gold/40 pl-5 text-base italic leading-relaxed text-neutral-400">
            {page.intro}
          </p>
        </Reveal>

        <div className="mt-14 space-y-12">
          {page.sections.map((section) => (
            <Reveal key={section.heading} delay={80}>
              <div>
                <h2 className="font-serif text-2xl font-light tracking-[0.03em] text-white">
                  {section.heading}
                </h2>
                <div className="mt-3 h-px w-10 bg-gold/60" />
                <p className="mt-5 text-base leading-relaxed text-neutral-400">{section.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
};

export default LegalPage;
